import React, { useEffect, useState } from "react";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import InputText from "../../../../components/modalComponents/InputText";
import InputSelect from "../../../../components/modalComponents/InputSelect";
import InputDate from "../../../../components/modalComponents/InputDate";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import { EXTENSION_PDF } from "../../../../constants/hardCodedConstants";
import PageButtons from "../../../../components/pageComponents/PageButtons";
import styled from "styled-components";
import { AlertErrorMaxExcelFileSizeMessage } from "../../../../components/alerts/AlertErrorMaxFileSizeMessage";
import GenericUploadFileV2 from "../../../../components/GenericUploadFile/GenericUploadFileV2";
import { useGetOptionsSelect } from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import { cargaSolicitudesBonoTutoriaMasivo, getAllSedesAPI, getDatosEmpleadoAPI, getEmpleadosToCreateCondicionAPI } from "../../../../consumers/backendApisUrls";
import { initialAllOptionPromises } from "../../../../helper/utils";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { faEdit, faSpinner } from "@fortawesome/free-solid-svg-icons";
import ActionsIcons from "../../../../components/atoms/ActionsIcons";
import PageTable from "../../../../components/pageComponents/PageTable";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import CustomCardAlert from "../../../../components/alerts/CustomCardAlert";
import CustomAlert from "../../../../components/alerts/CustomAlert";
import AlertOverlay from "../../../../components/alerts/AlertOverlay";

const BaseCampanaBonoTutoria = ({
    toggleModal,
    handleSubmit,
    puedeEditar,
    title,
    sectionName,
    filas,
    setFilas,
    allDropdowns,
    setAllDropdowns,
    formValues,
    setFormValues,
    solicitudes,
    setSoliciudes,
    commonProps,
    selectProps,
    isLoading,
    setIsLoading,
    isUploadingLineamientos,
    isUploadingExcel,
    setIsUploadingLineamientos,
    setIsUploadingExcel,
    paginator,
    setPaginator,
    KEYS,
    nuevo,
    IdCampanaBonoTutoria,
    registrosDuplicados,
    registrosErrados,
    showAlert,
    handleCloseAlert
}) => {
    const SECTION_NAME = sectionName;
    const [executeGet] = useManageGetRequest();
    const [executePost] = useManagePostRequest();
    const [editIndex, setEditIndex] = useState(null);

    const [modalEnabled, setModalEnabled] = useState({
        isEnable: false,
        component: React.Fragment,
    });
    const [uploadFileCargaMasiva, setUploadFileCargaMasiva] = useState();
    const UPDATE_REGISTRO_MENSUAL_INPUT_FILE = "ficha-edit-registro_mensual-file";
    const EXTENSIONES_VALIDAS = ["xls", "xlsx"];
    const defaultAlertMessage =
        "Se encontraron errores al momento de ingresar los registros";

    const rows = filas || [];

    const getPayloadExcel = () => {
        return {
            IdCampanaBonoTutoria: IdCampanaBonoTutoria,
            FechaTutorInicio: commonProps(KEYS.FechaInicioTutoria),
            FechaTutorFin: commonProps(KEYS.FechaFinTutoria),
            LineamientoFile: uploadFileCargaMasiva
        }
    }

    const handleIdEmpleadoChange = (e, i) => {
        const newValue = e.target.value;
        const newFilas = [...filas];
        newFilas[i].idEmpleado = newValue;
        setFilas(newFilas);
    };

    const handleEmpleadoEnter = async (e, row, i) => {
        console.log(i);
        console.log(row);
        console.log(filas);
        if (e.key === "Enter") {
            console.log(e.key);
            const idEmpleado = e.target.value;
            console.log(idEmpleado);
            if (!idEmpleado) return;

            const api = getDatosEmpleadoAPI(idEmpleado);
            try {
                const empleado = await executeGet(api, (res) => true);
                console.log(empleado.data)
                updateEmpleadoRow(i, empleado.data);
            } catch (error) {
                console.error("Error obteniendo empleado:", error);
            }
        }
    };

    const updateEmpleadoRow = (i, empleado) => {
        console.log(empleado)
        const newRows = [...filas];
        newRows[i] = {
            ...newRows[i],
            IdEmpleado: empleado.IdEmpleado,
            NombreCompleto: empleado.NombreCompleto,
            NombreSede: empleado.NombreSede,
            FechaTutorInicio: newRows[i].FechaTutorInicio || formValues[KEYS.FechaInicioTutoria],
            FechaTutorFin: newRows[i].FechaTutorFin || formValues[KEYS.FechaFinTutoria],
        };

        setFilas(newRows);
        console.log(filas)
        console.log(newRows)
    };

    const handleChangeFecha = (i, campo, valor) => {
        const newRows = [...filas];
        newRows[i][campo] = valor;
        setFilas(newRows);
    };
    const isRowEditable = (row, i) => {
        return editIndex === i || !row.IdSolicitudBonoTutoria;
    };

    const HEADERS = [
        { col: "col-sm-2", label: "Id Empleado" },
        { col: "col-sm-2", label: "Nombre" },
        { col: "col-sm-2", label: "Sede" },
        { col: "col-sm-2", label: "Fecha Tutoria Inicio" },
        { col: "col-sm-2", label: "Fecha Tutoria Fin" },
        //{ col: "col-sm-2", label: "Acciones" }
    ]
    const LoadingRow = () => (
        <tr>
            <td colSpan={HEADERS.length} className="text-center">
                <div className="d-flex justify-content-center align-items-center p-4">
                    <FontAwesomeIcon icon={faSpinner} spin size="2x" className="mr-2" />
                    <span className="ml-2">Cargando solicitudes...</span>
                </div>
            </td>
        </tr>
    );

    const formatDate = (dateStr) => {
        // suponiendo que viene como DD/MM/YYYY
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month}-${day}`; // YYYY-MM-DD
    };
    return (

        <ModalForm
            onSubmit={handleSubmit}
            showModal={toggleModal}
            width="1200px"
            titulo={title}>

            <div className="row">
                <div className="col-md-12">
                    <InputText
                        label="Nombre de campaña"
                        {...commonProps(KEYS.NombreCampana)}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputDate
                        label="Fecha inicio de campaña"
                        {...commonProps(KEYS.FechaInicioCampana)}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputDate
                        label="Fecha fin de campaña"
                        {...commonProps(KEYS.FechaFinCampana)}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputDate
                        label="Fecha inicio de tutoria"
                        {...commonProps(KEYS.FechaInicioTutoria)}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputDate
                        label="Fecha fin de tutoria"
                        {...commonProps(KEYS.FechaFinTutoria)}
                        direction="column"
                    />
                </div>

                <div className="col-md-12">
                    <InputUploadFile
                        label="Lineamientos"
                        name={KEYS.Lineamientos}
                        uploadFile={formValues[KEYS.LineamientoFile]}
                        setUploadFile={(res) =>
                            setFormValues({ ...formValues, [KEYS.LineamientoFile]: res })
                        }
                        sectionName={SECTION_NAME}
                        setIsUploadingLineamientos={setIsUploadingLineamientos}
                        validExtensions={EXTENSION_PDF}
                        direction="column"
                        NoFileMessage={isUploadingLineamientos ? "Subiendo archivo..." : "No se ha subido archivo"}
                    />
                </div>
            </div>
            <div className="row pb-3">
                <div className="col">
                    <div className="black-color ">
                        <div className="text-right">
                            <button
                                className="btn btn-primary generic-button-ficha-modal "
                                onClick={(e) => {
                                    e.preventDefault();
                                    setFilas([...filas, {}]);
                                }}>
                                Agregar
                            </button>
                        </div>
                        <div>
                            <InputUploadFile
                                label="Carga masiva"
                                id="input-carga-masiva-excel"
                                uploadFile={formValues[KEYS.CargaExcel]}
                                name={KEYS.CargaExcel}
                                setUploadFile={(res) =>
                                    setFormValues({ ...formValues, [KEYS.CargaExcel]: res })}
                                sectionName={SECTION_NAME}
                                ToastArchivoNoValido={AlertErrorMaxExcelFileSizeMessage}
                                setIsUploadingExcel={setIsUploadingExcel}
                                isUploadingExcel={isUploadingExcel}
                                textButton="Cargar Excel"
                                direction="column"
                                validExtensions={EXTENSIONES_VALIDAS}
                                NoFileMessage={isUploadingExcel ? "Subiendo archivo..." : "No se ha subido archivo"}
                            />
                        </div>

                    </div>
                </div>
            </div>
            {showAlert && (
                <AlertOverlay
                    defaultAlertMessage={defaultAlertMessage}
                    registrosDuplicados={registrosDuplicados}
                    registrosErrados={registrosErrados}
                    onClose={handleCloseAlert}
                />
            )}
            <div className="row">
                <div className="col">
                    <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
                        <tbody className="listar-tbody">
                            {!nuevo && isLoading && (!rows || rows.length === 0) ? (
                                <LoadingRow />
                            ) : rows &&
                            rows.map((row, i) => {
                                const editable = isRowEditable(row, i);
                                console.log(row)
                                return (
                                    <tr key={`${i}`}>
                                        <td className="">
                                            {/* ID EMPLEADO */}
                                            <input type="number" className="form-control"
                                                value={row.IdEmpleado || ""} // Asegura que no sea undefined
                                                onChange={(e) => handleIdEmpleadoChange(e, i)}
                                                onKeyDown={(e) => handleEmpleadoEnter(e, row, i)}
                                                placeholder="ingresar el idEmpleado"
                                                />
                                        </td>
                                        <td className="">
                                            {/* NOMBRE COMPLETO */}
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={row.NombreCompleto || ""}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="">
                                            {/* SEDE (Select deshabilitado) */}
                                            <Select
                                                placeholder="Sede"
                                                value={{ value: row.IdSede, label: row.NombreSede || 'N/A' }}
                                                isDisabled={true}
                                            />
                                        </td>
                                        <td className="">
                                            {/* FECHA TUTORIA INICIO */}
                                            <InputDate
                                                type="date"
                                                className="form-control"
                                                value={row.FechaTutorInicio ? formatDate(row.FechaTutorInicio) : ""}
                                                //onChange={e => handleChangeFecha(i, "FechaTutorInicio", e.target.value)}
                                                isDisabled={!editable}
                                            />
                                        </td>
                                        <td className="">
                                            {/* FECHA TUTORIA FIN */}
                                            <InputDate
                                                type="date"
                                                className="form-control"
                                                value={row.FechaTutorFin ? formatDate(row.FechaTutorFin) : ""}
                                                //onChange={e => handleChangeFecha(i, "FechaTutorFin", e.target.value)}
                                                isDisabled={!editable}
                                            />
                                        </td>
                                        {/**            <td className="text-center">
                                              
                                            <ActionsIcons>
                                                {!editable && <FontAwesomeIcon
                                                    icon={faEdit}
                                                    size="lg"
                                                    className="hand-pointer generic-action-icon"
                                                    title="Editar"
                                                    onClick={() => {
                                                        setEditIndex(i);
                                                    }}
                                                />}
                                                <FontAwesomeIcon
                                                    icon="trash"
                                                    className="hand-pointer"
                                                    title="Eliminar"
                                                    onClick={() => {
                                                        const newFilas = [...filas];
                                                        newFilas.splice(i, 1);
                                                        setFilas(newFilas);
                                                    }}
                                                />
                                                {editable && <FontAwesomeIcon
                                                    title='Cancelar'
                                                    icon="times"
                                                    onClick={() => {
                                                        setEditIndex(null);
                                                    }}
                                                />}
                                                {
                                                    <FontAwesomeIcon
                                                        title='save'
                                                        icon="save"
                                                        // Aquí podrías agregar la lógica para guardar la edición en línea 
                                                        // (si se edita una solicitud ya existente en la DB)
                                                        onClick={() => {
                                                            setEditIndex(null);
                                                        }}
                                                    />}
                                            </ActionsIcons>
                                        </td> */}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </PageTable>
                    <p className="ficha-form-input-validation-message" id={`ficha-edit-${SECTION_NAME}-Topes-validation-message`}></p>
                </div>
            </div>
        </ModalForm>
    );
}
export default BaseCampanaBonoTutoria;
const ButtonsWrapper = styled.div`
  display: block;
  @media (max-width: 796px){
    display: none;
  }
`;